<template>
  <NotificationMessenger ref="notification" :message="notificationMessage" />

  <section>
    <div class="titulo">
      <div class="margem container">
        <h2>Relatório de inspeções</h2>
      </div>
    </div>
    <div class="margem container">
      <h2>Inspeção diária</h2>
      <div class="bloco margem">
        <SelectableTags v-model="filtroDiario" :options="diarioFilterWithCounts" />

        <div v-if="!isLoading" class="grid-4 margem">
          <div v-for="ele in maquinasDiaria" v-bind:key="ele.id" class="bloco container inspecao-card" @click="filtroDiario === 'nao-realizada' ? null : abrirModal(ele.inspection)">
            <div>
              <strong>{{ ele.code }}</strong> - {{ ele.name }}
            </div>
            <div :class="getIcon(ele)">{{}}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="separador"> <div></div></div> -->

    <div class="margem container filter-container">
      <h2>Relatório</h2>
      <div class="bloco margem">
        <div class="linha" style="justify-content: space-between">
          <SelectableTags title="Filtrar por:" v-model="activeFilter" :options="filters" />

          <div class="fonte-maior icone-download clicavel" @click="downloadXlxs">Baixar relatório</div>
        </div>

        <div class="margem container linha date-line">
          <SingleSelectDropdown :title="dropdownTitle" :options="options[activeFilter]" v-model="optionSelected" style="flex-grow: 2" />
          <SingleSelectDropdown title="Status" :options="statusOptions" v-model="statusSelected" />

          <div class="coluna alinha-centro">
            <div>
              <h3 class="alinha-centro">Intervalo de busca</h3>
              <div class="linha alinha-v">
                <div>De</div>
                <input type="date" v-model="startDate" />
                até
                <input type="date" v-model="endDate" />
              </div>
            </div>
          </div>
        </div>
        <button class="search-btn" @click="filter">Filtrar</button>
      </div>
    </div>

    <div class="margem container">
      <div v-if="isLoading" class="loading"><div></div></div>
      <div v-if="!isLoading" class="margem bloco container">
        <table class="tabela">
          <tbody>
            <tr>
              <th>Datahora</th>
              <th>Máquina</th>
              <th>Colaborador</th>
              <th>Conforme</th>
              <th v-if="temPermissao(177)">Ações</th>
            </tr>
            <tr v-for="ele of filteredInspections" v-bind:key="ele.id" @click="abrirModal(ele)" class="insp-tr clicavel">
              <td>
                {{ parseDate(ele.doneAt, true) }}
              </td>
              <td>{{ ele.machine.label }}</td>
              <td>{{ ele.responsible.name }}</td>
              <td>
                <div :class="ele.isWorking === false ? 'icone-pause' : ele.status ? 'icone-check' : 'icone-cancel'"></div>
              </td>
              <td v-if="temPermissao(177)">
                <div class="icone-delete clicavel" @click.stop="abrirModalExcluir(ele)"></div>
              </td>
            </tr>
          </tbody>
        </table>
        <div style="display: flex; justify-content: center" v-if="filteredInspections.length == 0">Nenhum dado para o intervalo indicado</div>

        <PaginationComponent
          v-if="filteredInspections.length > 0"
          :current-page="paginationData.currentPage"
          :total-pages="paginationData.lastPage"
          :per-page="paginationData.perPage"
          :total="paginationData.total"
          :from="paginationData.from"
          :to="paginationData.to"
          @page-changed="handlePageChange"
          @per-page-changed="handlePerPageChange"
        />
      </div>
    </div>
  </section>

  <!-- MODAL DETALHES INSPEÇÃO -->
  <SimpleModal :show="modalInspecionar" @close="modalInspecionar = false">
    <div style="text-align: center; width: 100%">
      <div>
        <h2>Resultado da inspeção de {{ currentInspection.machine.name }}</h2>
        <h3>{{ currentInspection.machine.code }}</h3>

        <div class="linha" style="justify-content: center">
          <div>Realizada por:<br />{{ currentInspection.responsible.name }}</div>
          <div>Em:<br />{{ parseDate(currentInspection.doneAt, true) }}</div>
        </div>

        <br />
        <div v-if="currentInspection.isWorking === false">
          <div>Máquina parada. Motivo:</div>
          <div>
            <strong>{{ currentInspection.remarks }}</strong>
          </div>
        </div>
        <div v-if="currentInspection.isWorking">
          <div v-for="ele of currentInspection.params" v-bind:key="ele.id">
            <div :class="ele.status ? 'icone-check' : 'icone-cancel'">{{ ele.description }}</div>
            <div>Observações:<br />{{ ele.remark ?? "-" }}</div>

            <div class="imagem-wrapper">
              <div v-for="img of ele.attachments" v-bind:key="img.nome_original" class="imagem-container">
                <div class="imagem-inner">
                  <img :src="getImageUrl(img)" class="imagem-parametro" alt="teste" />
                  <div class="bottom-img-bar">
                    <a :href="getImageUrl(img)" target="_blank" class="segment">
                      <div class="icone-olho"></div>
                      <div>Ver</div>
                    </a>

                    <div @click.prevent="downloadFile(img)" class="segment">
                      <div class="icone-download"></div>
                      <div>Download</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </SimpleModal>

  <ActionModal :show="modalExcluir" @close="modalExcluir = false">
    <div style="text-align: center; width: 100%; display: flex; flex-direction: column; gap: 15px">
      <h2 style="text-align: center">Tem certeza que deseja excluir está inspeção?</h2>
      <h3>{{ currentInspection.machine.label }}</h3>

      <div class="linha" style="justify-content: center">
        <div>
          Realizada por:<br /><strong>{{ currentInspection.responsible.name }}</strong>
        </div>
        <div>
          Em:<br /><strong>{{ parseDate(currentInspection.doneAt, true) }}</strong>
        </div>
      </div>
      <div v-if="currentInspection.isWorking === false">
        <div>
          Status:<br /><strong>{{ currentInspection.isWorking ? "Máquina em funcionamento" : "Máquina parada" }}</strong>
        </div>
        <div>
          Motivo:<br /><strong>{{ currentInspection.remarks }}</strong>
        </div>
      </div>
      <div v-else>
        <div>Máquina em funcionamento.</div>
        <div>
          Status da inspeção: <br /><strong> {{ currentInspection.status ? "Conforme" : "Inconforme" }}</strong>
        </div>
      </div>
      <br />
    </div>
    <template #actions>
      <div>
        <button class="acao-secundaria" @click="modalExcluir = false">Cancelar</button>
      </div>
      <div v-if="excluindo === false">
        <button @click="deletarInspecao(currentInspection)">Confirmar</button>
      </div>
      <div v-else>
        <div class="loading"><div></div></div>
      </div>
    </template>
  </ActionModal>

  <!-- END MODAL -->
</template>

<script>
import { SingleSelectDropdown, SimpleModal, SelectableTags, ActionModal, PaginationComponent, usePermissions } from "roboflex-thalamus-componentes-vue3-lib";
import { PersonDataSource } from "@/data/datasource/PersonDataSource";
import InspectionDataSource from "@/data/datasource/inspection/InspectionDataSource";
import NotificationMessenger from "@/components/NotificationMessenger.vue";

const { loadPermissions, temPermissao } = usePermissions();
const personDataSource = new PersonDataSource();

export default {
  components: {
    SelectableTags,
    SingleSelectDropdown,
    SimpleModal,
    ActionModal,
    NotificationMessenger,
    PaginationComponent,
  },

  data() {
    const today = new Date();
    const firstDayLastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);

    return {
      notificationMessage: "",
      options: {
        operador: [],
        máquina: [],
      },
      allMachinesForInspection: [], // Machines for daily inspection section
      filters: [
        { label: "Operador", value: "operador" },
        { label: "Máquina", value: "máquina" },
      ],
      activeFilter: "operador",
      statusOptions: [
        { label: "Conforme", value: 1 },
        { label: "Inconforme", value: 0 },
      ],
      statusSelected: null,
      startDate: firstDayLastMonth.toISOString().split("T")[0],
      endDate: today.toISOString().split("T")[0],
      isLoading: false,
      todayInspections: [], // Static inspections for today only (not affected by date filters)
      filteredInspections: [],
      modalInspecionar: false,
      modalExcluir: false,
      excluindo: false,
      filtroDiario: "conforme",
      paginationData: {
        currentPage: 1,
        lastPage: 1,
        perPage: 30,
        total: 0,
        from: 0,
        to: 0,
      },
    };
  },

  async created() {
    this.isLoading = true;
    try {
      await loadPermissions();
      await this.fetchInitialData();
      await this.fetchTodayInspections();
      await this.filter();
    } finally {
      this.isLoading = false;
    }
  },

  computed: {
    dropdownTitle() {
      const article = this.activeFilter === "operador" ? "o" : "a";
      return `Selecione ${article} ${this.activeFilter}`;
    },
    machinesWithInspections() {
      if (!Array.isArray(this.todayInspections) || !this.allMachinesForInspection) return [];
      return this.allMachinesForInspection.map((machine) => {
        const inspection = this.todayInspections.find((ins) => ins.machine?.id === machine.id);
        return { ...machine, inspection };
      });
    },

    maquinasDiaria() {
      if (!this.machinesWithInspections.length) return [];

      const filterMap = {
        conforme: (m) => m.inspection?.status === 1,
        inconforme: (m) => m.inspection?.status === 0,
        "nao-realizada": (m) => !m.inspection,
        paradas: (m) => m.inspection?.isWorking === false,
      };

      const filterFn = filterMap[this.filtroDiario];
      return filterFn ? this.machinesWithInspections.filter(filterFn) : [];
    },

    diarioFilterWithCounts() {
      const baseFilters = [
        { label: "Conformes", value: "conforme" },
        { label: "Inconformes", value: "inconforme" },
        { label: "Não realizadas", value: "nao-realizada" },
        { label: "Paradas", value: "paradas" },
      ];

      if (!this.machinesWithInspections.length) return baseFilters;

      const counts = {
        conforme: this.machinesWithInspections.filter((m) => m.inspection?.status === 1).length,
        inconforme: this.machinesWithInspections.filter((m) => m.inspection?.status === 0).length,
        "nao-realizada": this.machinesWithInspections.filter((m) => !m.inspection).length,
        paradas: this.machinesWithInspections.filter((m) => m.inspection?.isWorking === false).length,
      };

      return baseFilters.map((filter) => ({
        ...filter,
        label: `${filter.label} (${counts[filter.value]})`,
      }));
    },
  },

  methods: {
    temPermissao,
    // Initialization
    async fetchInitialData() {
      const [people, machines, machinesForInspection] = await Promise.all([personDataSource.getPeople(), InspectionDataSource.getMachines(), InspectionDataSource.getMachinesByCategories()]);
      this.options = { operador: people, máquina: machines };
      this.allMachinesForInspection = machinesForInspection;
    },

    async fetchTodayInspections() {
      // Fetch only today's inspections (static, not affected by date range filter)
      const today = new Date().toISOString().split("T")[0];
      const allTodayInspections = await InspectionDataSource.getInspections(false, today, today);
      // Filter to ensure we only have today's inspections
      this.todayInspections = allTodayInspections.filter((inspection) => {
        const dateStr = inspection.doneAt ?? inspection.created_at;
        if (!dateStr) return false;
        return new Date(dateStr).toISOString().slice(0, 10) === today;
      });
    },

    async filter() {
      this.paginationData.currentPage = 1;
      await this.fetchPaginatedData();
    },

    async fetchPaginatedData() {
      this.isLoading = true;
      try {
        const response = await InspectionDataSource.getInspections(true, this.startDate, this.endDate, this.paginationData.currentPage, this.paginationData.perPage);
        let filteredInspections = response.data;

        // Apply status filter
        if (this.statusSelected) {
          filteredInspections = filteredInspections.filter((i) => i.status === this.statusSelected.value);
        }

        // Apply operator or machine filter
        if (this.optionSelected) {
          const filterKey = this.activeFilter === "operador" ? "responsible" : "machine";
          filteredInspections = filteredInspections.filter((i) => i[filterKey].id === this.optionSelected.id);
        }

        this.filteredInspections = filteredInspections;
        this.paginationData = response.pagination;
      } finally {
        this.isLoading = false;
      }
    },

    async handlePageChange(page) {
      this.paginationData.currentPage = page;
      await this.fetchPaginatedData();
    },

    async handlePerPageChange(perPage) {
      this.paginationData.perPage = perPage;
      this.paginationData.currentPage = 1;
      await this.fetchPaginatedData();
    },

    abrirModal(inspection) {
      this.currentInspection = inspection;
      if (inspection.isWorking) {
        this.loadInspectionDetails(inspection);
      } else {
        this.modalInspecionar = true;
      }
    },

    async loadInspectionDetails(inspection) {
      try {
        this.currentInspection = await InspectionDataSource.getSpecifInspection(inspection);
        this.modalInspecionar = true;
      } catch (error) {
        this.notificationMessage = `Erro ao carregar detalhes: ${error.message || error}`;
      }
    },

    abrirModalExcluir(inspection) {
      this.currentInspection = inspection;
      this.modalExcluir = true;
    },

    async deletarInspecao(inspection) {
      this.excluindo = true;
      try {
        await InspectionDataSource.deletarInspecao(inspection);
        this.modalExcluir = false;

        // Remove from todayInspections if it's today's inspection
        const today = new Date().toISOString().slice(0, 10);
        const inspectionDate = new Date(inspection.doneAt ?? inspection.created_at).toISOString().slice(0, 10);
        if (inspectionDate === today) {
          this.todayInspections = this.todayInspections.filter((ins) => ins.id !== inspection.id);
        }

        // Update paginated data
        await this.fetchPaginatedData();
      } catch (error) {
        this.notificationMessage = `Erro ao excluir inspeção: ${error.msg ?? error.message ?? error}`;
      } finally {
        this.excluindo = false;
        this.currentInspection = null;
      }
    },

    getImageUrl(img) {
      const baseUrl = process.env.NODE_ENV === "production" ? "https://api.thalamus.ind.br" : "https://api.thalamus-homologacao.ind.br:8000";
      return `${baseUrl}/storage/${img.caminho}`;
    },

    async downloadFile(img) {
      try {
        const response = await fetch(this.getImageUrl(img));
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = img.nome_original;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        this.notificationMessage = `Erro ao baixar arquivo: ${error.message || error}`;
      }
    },

    async downloadXlxs() {
      try {
        const file = await InspectionDataSource.downloadXlxs();
        const blob = new Blob([file.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "Relatório.xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        this.notificationMessage = `Erro ao baixar relatório: ${error.msg ?? error.message ?? error}`;
      }
    },

    getIcon(machine) {
      if (!machine.inspection) return "icone-pending";
      if (machine.inspection.isWorking === false) return "icone-pause";
      return machine.inspection.status ? "icone-check" : "icone-cancel";
    },

    parseDate(date, withHour = false) {
      if (!date) return "-";
      const dateObj = new Date(date);
      return withHour ? dateObj.toLocaleString().replace(",", " -") : dateObj.toLocaleDateString();
    },
  },
};
</script>

<style scoped>
.icone-delete {
  visibility: hidden;
}

.insp-tr:hover .icone-delete {
  visibility: visible;
}

.icone-download {
  padding-right: 0 !important;
}

.icone-pause {
  transform: scale(1.2);
}

.inspecao-card {
  text-align: center;
  padding: 12px 6px 0px 6px;

  .icone-pending,
  .icone-check,
  .icone-cancel {
    display: flex;
    justify-content: center;
    transform: scale(1.25);
  }
}

.inspecao-card:hover {
  box-shadow: 3px 3px 10px var(--cor-primaria-media);
  border: 1px solid var(--cor-primaria-media);
  cursor: pointer;
}

.search-btn {
  display: flex;
  justify-self: end;
}

.blue-bg {
  font-size: x-large;
  background-color: blue;
}

.imagem-wrapper {
  display: flex;
  gap: 10px;
  flex-direction: row;
  justify-content: center;
  overflow-x: auto;
  scroll-behavior: smooth;
}

.imagem-container {
  flex: 0 0 auto;
  border: 1px solid rgb(196, 196, 196);
  border-radius: 10px;
  background-color: white;
  overflow: hidden;
  width: 250px;
}

.imagem-container:hover .imagem-parametro {
  transform: scale(1.05);
}

.imagem-parametro {
  border-radius: 10px 10px 0 0;
  height: 250px;
  width: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.3s ease-in-out;
  border-bottom: 1px solid var(--cor-separador);
}

.bottom-img-bar {
  display: flex;
  justify-content: space-around;
  align-items: center;
  background-color: #f9f9f9;
  font-size: 0.9rem;
  border-radius: 0 0 10px 10px;
}

.segment {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
}

.segment:hover {
  cursor: pointer;
  font-size: large;
  color: var(--cor-primaria-forte);
}
</style>
